export type ProfileExpertiseGroup = {
  id?: number | null;
  en_slug?: string | null;
  name?: string | null;
};

export type ProfileExpertises = {
  group_expertises?: ProfileExpertiseGroup[];
  expertises?: unknown[];
};

const PSYCHOLOGY_SPECIALITY_SLUG = 'psychology';

/**
 * Psychologists address their patients as «مراجع» instead of «بیمار».
 * Detected at the speciality-group level (روانشناسی = `psychology`),
 * so psychiatry (a separate group) is intentionally not matched.
 */
export const isPsychologist = (expertises?: ProfileExpertises | null) =>
  Boolean(expertises?.group_expertises?.some(group => group?.en_slug === PSYCHOLOGY_SPECIALITY_SLUG));
